<!--
  -  TTTech nerve-management-system
  -  Copyright(c) 2022. TTTech Industrial Automation AG.
  -
  -  ALL RIGHTS RESERVED.
  -
  -  Usage of this software, including source code, netlists, documentation,
  -  is subject to restrictions and conditions of the applicable license
  -  agreement with TTTech Industrial Automation AG or its affiliates.
  -
  -  All trademarks used are the property of their respective owners.
  -
  -  TTTech Industrial Automation AG and its affiliates do not assume any liability
  -  arising out of the application or use of any product described or shown
  -  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
  -  make changes, at any time, in order to improve reliability, function or
  -  design.
  -
  -  Contact Information:
  -  support@tttech-industrial.com
  -
  -  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
  -
  -->

<template>
  <v-main scrollable>
    <div id="core-view">
      <Login v-if="isAuthLayout" :logo="'/img/login.svg'" :image="'/img/login-background.webp'">
        <template #login-actions>
          <v-fade-transition mode="out-in">
            <router-view :key="$route.meta?.viewKey ?? $route.path"></router-view>
          </v-fade-transition>
        </template>
      </Login>
      <v-fade-transition v-else mode="out-in">
        <router-view :key="$route.meta?.viewKey ?? $route.path"></router-view>
      </v-fade-transition>
    </div>
    <ApiToast />
    <ApiMessageBox />
    <ApiLoadingBar />
    <ConfirmDialog />
    <ApiPermissionConfirmationDialog />
    <ApplyWorkloadConfigurationDialog />
    <NotificationDialog />
    <ProgressBarDialog />
    <DeployInfoDialog />
    <ApiLoadingCircular />
  </v-main>
</template>

<script setup>
import ApiToast from '@/components/api-dialogs/ApiToast.vue';
import ApiMessageBox from '@/components/api-dialogs/ApiMessageBox.vue';
import ApiLoadingBar from '@/components/api-dialogs/ApiLoadingBar.vue';
import ConfirmDialog from '@/components/api-dialogs/Confirm.vue';
import ApiPermissionConfirmationDialog from '@/components/roles/ApiPermissionConfirmDialog.vue';
import ApplyWorkloadConfigurationDialog from '@/components/nodes/deployed-workload-control/ApplyWorkloadConfigurationDialog.vue';
import NotificationDialog from '@/components/api-dialogs/NotificationDialog.vue';
import DeployInfoDialog from '@/components/api-dialogs/DeployInfoDialog.vue';
import ProgressBarDialog from '@/components/api-dialogs/ProgressBarDialog.vue';
import ApiLoadingCircular from '@/components/api-dialogs/ApiLoadingCircular.vue';
import useLdapStore from '@/store/modules/pinia/ldap';
import { Login } from '@nerve/ui-components';

import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const isAuthLayout = computed(() => route.meta?.authLayout);

onMounted(async () => {
  try {
    const ldapStore = useLdapStore();
    await ldapStore.getLdapStatus();
  } catch (e) {
    console.debug(e);
  }
});
</script>
